import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { DateTime } from "luxon";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

import { useCreateSale } from "../../../hooks/useSale";

// Todo: Validation for if year exists, or if year is in the past.

// Todo: interpert error messages for user freindly responses

const cancelIcon = <FontAwesomeIcon icon={faXmark} />
const checkIcon = <FontAwesomeIcon icon={faCheck} />

export default function SaleAdd() {

  const [startDate, setStartDate] = useState(DateTime.local().toISODate())
  const [endDate, setEndDate] = useState(DateTime.local().toISODate())
  const [consignmentStart, setConsignmentStart] = useState(DateTime.local().toISODate())
  const [consignmentEnd, setConsignmentEnd] = useState(DateTime.local().toISODate())
  const [error, setError] = useState(null)
  const createSale = useCreateSale()
  const navigate = useNavigate()

  const save = () => {
    createSale.mutateAsync({
      sale_start: startDate,
      sale_end: endDate,
      consignment_start: consignmentStart,
      consignment_end: consignmentEnd
    })
    .then(res => navigate('/admin/sales'))
    .catch((err => setError(err)))
  }

  return (
    <div className="form has-text-left">
      <div className="title">Add Sale</div>
      {error &&
        <div className="notification is-danger">
          {createSale.error.message}
        </div>
      }
      <div className="field">
        <label className="label">Start Date</label>
        <div className="control">
          <input className="input" type="date" value={startDate} onChange={
            e => setStartDate(e.target.value)} />
        </div>
      </div>
      <div className="field">
        <label className="label">End Date</label>
        <div className="control">
          <input className="input" type="date" value={endDate} onChange={
            e => setEndDate(e.target.value)
          } />
        </div>
      </div>
      <div className="field">
        <label className="label">Consignment Start</label>
        <div className="control">
          <input className="input" type="date" value={consignmentStart} onChange={
            e => setConsignmentStart(e.target.value)
          } />
        </div>
      </div>
      <div className="field">
        <label className="label">Consignment End</label>
        <div className="control">
          <input className="input" type="date" value={consignmentEnd} onChange={
            e => setConsignmentEnd(e.target.value)
          } />
        </div>
      </div>
      <div className="buttons is-grouped">
        <button className="button is-link" onClick={save} disabled={createSale.isLoading}>
          <span className="icon">
            <i>{checkIcon}</i>
          </span>
          <span>Save</span>
        </button>
        <button className="button is-info" onClick={() => navigate('/admin/sales')}>
          <span className="icon">
            <i>{cancelIcon}</i>
          </span>
          <span>Cancel</span>
        </button>
      </div>
    </div>
  )
}
